import React from 'react';
import { useOutletContext } from 'react-router-dom';
import BookingsCalendarTab from '../organization/venue-booking/BookingsCalendarTab';

export default function VenueOwnerCalendarPage() {
  const { venues } = useOutletContext();
  return (
    <div data-testid="venue-owner-calendar-page">
      {venues.length === 0 ? (
        <p className="rounded-2xl border border-slate-200 bg-white p-6 text-center text-sm text-slate-500" data-testid="venue-owner-calendar-no-venues">
          أضف ملعباً أولاً من تبويب «الملاعب والكورتات» لتتمكن من عرض التقويم
        </p>
      ) : (
        <BookingsCalendarTab venues={venues} canManage />
      )}
    </div>
  );
}
